!function(global, factory) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = factory() : "function" == typeof define && define.amd ? define(factory) : global.shallowCompare = factory();
}(this, function() {
    "use strict";
    function shallowDiffers(a, b) {
        for (var i in a) if (!(i in b)) return !0;
        for (var _i in b) if (a[_i] !== b[_i]) return !0;
        return !1;
    }
    var index = function(instance, nextProps, nextState) {
        return shallowDiffers(instance.props, nextProps) || shallowDiffers(instance.state, nextState);
    };
    return index;
});
//# sourceMappingURL=preact-shallow-compare.js.map